import { render, staticRenderFns } from "./sku.vue?vue&type=template&id=50a9aab5&scoped=true"
import script from "./sku.vue?vue&type=script&lang=ts"
export * from "./sku.vue?vue&type=script&lang=ts"
import style0 from "./sku.vue?vue&type=style&index=0&id=50a9aab5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a9aab5",
  null
  
)

export default component.exports